import "mmenu-light/dist/mmenu-light.polyfills"
import MmenuLight from "mmenu-light"

document.addEventListener("DOMContentLoaded", () => {
	const node = document.querySelector("[data-smallmenu]")
	const wrapper = document.querySelector("[data-smallmenu-wrapper]")
	const menu = new MmenuLight(node, {
		selected: "mm--selected",
	})

	menu.enable()
	node.classList.remove("smallmenu")
	menu.offcanvas({
		position: "right",
	})

	document
		.querySelector("[data-smallmenu-trigger]")
		.addEventListener("click", evnt => {
			wrapper.classList.add("wrapper--opened")
			menu.open()
			evnt.stopPropagation()
		})

	node.addEventListener(
		"mm:close",
		() =>
			console.log("close") || wrapper.classList.remove("wrapper--opened")
	)
})
